import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../common/Input';
import Card from '../../common/Card';
import Label from '../../common/Label';
import Choice from '../../common/Choice';
import SelectSearch from '../../common/SelectSearch';
import MultiSelect from '../../common/MultiSelect';
import Pagination from '../../common/Pagination';
import Button from '../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../common/Modal';
import CardPriceSearch from './CardPriceSearch';
import '../../../assets/css/pages/stores/price-search.css';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    fetchCompetitorChainsByStoreCode,
    fetchCompetitorStoresByStoreCode,
    fetchDepartments,
    fetchExpandSalesFloors,
    fetchItemCategories,
    fetchPackingCategories,
    fetchRegistrationMethods,
    fetchSaleTypes,
    fetchSources,
    setLoader,
} from '../../../redux/actions/api';
import { setToastsSuccess } from '../../../redux/actions/common';
import { SEARCH_METHOD, STOP_PURCHASE_FLAG } from '../../../utils/constants/string';
import {
    ChangeRequestCompetitorCreateRequest,
    ChangeRequestControllerService,
    ConstantsControllerService,
    ErrorMessage,
    PriceSearchControllerService,
    PriceSearchRequest,
    VariantProductControllerService,
} from '../../../services';
import SelectTable from '../../tables/SelectTable';
import ViewTable from '../../tables/ViewTable';
import { getCompetitorRequestTable, getFreshnessRequestTable, getLowerLimitTable, getSearchTable } from '../../tables/table';
import env from '../../../configs/env';
import { discountValidation, validateSearchInput, validateRegisterInput, validateFormInput } from '../../../utils/helpers/validation';
import { setIsContinue, setIsVariantProductsContinue, setShowLinkedItem, setVariantProducts } from '../../../redux/actions/modal';
import { formattedDate } from '../../../utils/helpers/date';
import apiErrorHandler, { apiChangeRequestErrorHandler, apiValidationErrorHandler, getErrorItems } from '../../../api/apiErrorHandler';
import { clearErrors } from '../../../redux/actions/error';
import InputJan from '../../common/InputJan';
import EditTable from '../../tables/EditTable';
import { getLowerPrice, getSellingPrices, getTaxIncludedPrice } from '../../../utils/helpers/formula';
import { setChangeRequestType, setIsAllowValidate } from '../../../redux/actions/storage';
import { checkEnableSelect, isAllUnit, isIOS } from '../../../utils/helpers/common';
import { EitherOneRequiredText } from '../../common/RequiredBadge';
import DuplicateModal from '../../modals/DuplicateModal';

const DEFAULT_STATE = {
    selectedRows: [],
    requestData: [],
    lowerLimitData: [],

    selectedCompetitorStoreCode: '',
    requesterName: '',
    selectedSource: 'FLYER',
    selectedRegistrationMethod: 'FORM',

    itemName: '',
    searchMethod: 'PARTIAL',
    jan: '',
    lines: [],
    classes: [],
    subclasses: [],
    selectedDepartments: [],
    selectedLine: null,
    selectedClass: null,
    selectedSubclass: null,
    selectedItemCategory: 'ALL',
    selectedStopPurchaseFlag: '0',
    otherSpecialReports: '',
    showLowerLimitModal: false,
    showSearchLimitCountModal: false,
    isChange: new Date(),
    isAllUnitSelected: false,

    page: 1,
    limit: 20,
    apiResponse: null,
    isShowTableMaster: false,
    isShowModalRegister: false,
    isCameraOpen: false,

    // 重複確認モーダル
    duplicateModalIsShow: false,
    duplicateModalProps: null,
};

const DEFAULT_FORM_DATA = {
    expandSalesFloor: ChangeRequestCompetitorCreateRequest.expandSalesFloor.REGULAR,
    discountedRequestSellingPrice: '',
    packingCategory: ChangeRequestCompetitorCreateRequest.packingCategory.SINGLE_ITEM,
    saleType: ChangeRequestCompetitorCreateRequest.saleType.WEEKLY,
    salesStartDate: '',
    salesEndDate: '',
    otherSpecialReports: '',

    // 割引率
    // ※ 割引率はフロント側でのみ使用されているため、
    // 通常であればAPIでサーバーに送る必要はないが、
    // 割引率がどれくらい利用されているかを調査したいとの要望により、
    // 割引率をAPIのリクエストに含め、APIのアクセスログで見れるようにする
    discountRate: '',
    freshnessReason: '賞味期限間近',
    reportFlag: false,
};

const PriceSearch = ({ paramCompetitorStoreCode }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useNavigate();
    const location = useLocation();

    const sort = useSelector((state) => state.sort);

    const constants = useSelector((state) => state.constants);
    const {
        itemCategories,
        expandSalesFloors,
        packingCategories,
        saleTypes,
        competitorChains,
        competitorStores,
        sources,
        registrationMethods,
        departments,
    } = constants;

    const createCompetitorStoreOptions = () => {
        return (
            competitorStores?.map((item) => ({
                value: item.competitorStoreCode,
                label: item.competitorStoreName,
            })) ?? []
        );
    };

    const storage = useSelector((state) => state.storage);
    const { isCompetitor, isFreshness, isInstruction, isHeadquarter, isHead, changeRequestType, isAllowValidate } = storage;

    const modal = useSelector((state) => state.modal);
    const { isContinue, isVariantProductsContinue } = modal;

    const handleDeleteClick = (index, value) => {
        const newSelectedRows = selectedRows.filter((item, i) => i !== index);
        handleChangeState('selectedRows', newSelectedRows);
    };
    const [taxIncludedType, setTaxIncludedType] = useState('excluded');

    // デフォルト状態を取得する
    const getDefaultState = () => {
        return {
            ...DEFAULT_STATE,
            ...{
                selectedCompetitorStoreCode: paramCompetitorStoreCode ?? '',
                selectedRegistrationMethod: isHead ? 'EXCEL' : 'FORM',
            },
        };
    };

    const [state, setState] = useState(getDefaultState);

    const {
        selectedRows,
        requestData,
        lowerLimitData,

        selectedCompetitorStoreCode,
        requesterName,
        selectedSource,
        selectedRegistrationMethod,

        itemName,
        searchMethod,
        jan,
        lines,
        classes,
        subclasses,
        selectedDepartments,
        selectedLine,
        selectedClass,
        selectedSubclass,
        selectedItemCategory,
        selectedStopPurchaseFlag,
        showLowerLimitModal,
        showSearchLimitCountModal,
        isChange,
        isAllUnitSelected,

        page,
        limit,
        apiResponse,
        isShowTableMaster,
        isShowModalRegister,
        isCameraOpen,

        // 重複確認モーダル
        duplicateModalIsShow,
        duplicateModalProps,
    } = state;

    const [formData, setFormData] = useState({
        ...DEFAULT_FORM_DATA,
    });

    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const isSelectExcel = selectedRegistrationMethod === 'EXCEL';
    const isHiddenButtonCompletion = isSelectExcel || isHeadquarter;

    const table = getSearchTable(t, isFreshness);
    const tableSelect = getSearchTable(t, isFreshness, isSelectExcel, handleDeleteClick);
    const tableRequest = isFreshness
        ? getFreshnessRequestTable(t, taxIncludedType)
        : getCompetitorRequestTable(t, expandSalesFloors, packingCategories, saleTypes, taxIncludedType);

    useEffect(() => {
        dispatch(clearErrors());
        setState({
            ...getDefaultState(),
            selectedRows: [],
        });
        dispatch(fetchItemCategories());
        dispatch(fetchExpandSalesFloors());
        dispatch(fetchPackingCategories());
        dispatch(fetchSaleTypes());
        dispatch(fetchCompetitorStoresByStoreCode());
        dispatch(fetchCompetitorChainsByStoreCode());
        dispatch(fetchSources());
        dispatch(fetchRegistrationMethods());
        dispatch(fetchDepartments());
        if (isHead) {
            dispatch(setChangeRequestType(PriceSearchRequest.changeRequestType.FLYER));
        }
    }, [dispatch, location.key]);

    useEffect(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        handleSubmitForm(page);
    }, [sort]);

    // 部門が変更された場合
    useEffect(() => {
        // 部門一覧が取得できている場合のみ
        // ※ 初回時などは部門一覧がまだ取得できていない可能性がある
        if (departments?.length) {
            // ライン名、クラス名、サブクラス名をクリア
            setState((prevState) => ({
                ...prevState,

                lines: [],
                selectedLine: null,

                classes: [],
                selectedClass: null,

                subClasses: [],
                selectedSubclass: null,
            }));

            (async () => {
                try {
                    // 部門コード一覧
                    // 部門が選択済の場合は、その部門コードを使用
                    // 部門が未選択の場合は、全ての部門コードを使用
                    const departmentCodes = (selectedDepartments.length ? selectedDepartments : departments).map((e) => e.value);

                    // ライン一覧を取得
                    const response = await ConstantsControllerService.getLines(departmentCodes);
                    const lines = response.map((item) => ({
                        value: item.lineCode,
                        label: item.divisionName,
                        departmentCode: item.departmentCode,
                    }));
                    handleChangeState('lines', lines);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, departments, selectedDepartments]);

    // ライン名が変更された場合
    useEffect(() => {
        // クラス名、サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            classes: [],
            selectedClass: null,

            subClasses: [],
            selectedSubclass: null,
        }));

        // ライン名が選択されている場合のみ
        if (selectedLine) {
            (async () => {
                try {
                    // クラス一覧を取得
                    const response = await ConstantsControllerService.geClasses(selectedLine.value);
                    const classes = response.map((item) => ({
                        value: item.classCode,
                        label: item.divisionName,
                        lineCode: item.lineCode,
                    }));
                    handleChangeState('classes', classes);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedLine]);

    // クラス名が変更された場合
    useEffect(() => {
        // サブクラス名をクリア
        setState((prevState) => ({
            ...prevState,

            subClasses: [],
            selectedSubclass: null,
        }));

        // クラス名が選択されている場合のみ
        if (selectedClass) {
            (async () => {
                try {
                    // サブクラス一覧を取得
                    const response = await ConstantsControllerService.geSubclasses(selectedClass.lineCode, selectedClass.value);
                    const subclasses = response.map((item) => ({
                        value: item.subclassCode,
                        label: item.divisionName,
                    }));
                    handleChangeState('subclasses', subclasses);
                } catch (error) {
                    apiErrorHandler(dispatch, error);
                }
            })();
        }
    }, [dispatch, selectedClass]);

    // JAN が変更された
    const handleJanChange = (newJan) => {
        setState((prevState) => ({
            ...prevState,

            // JAN
            jan: newJan,

            // JAN が入力されていた場合
            // JAN 以外の検索条件を初期状態に戻す
            ...(newJan !== '' && {
                itemName: DEFAULT_STATE.itemName, // 商品名
                searchMethod: DEFAULT_STATE.searchMethod, // 商品名の検索条件

                selectedDepartments: DEFAULT_STATE.selectedDepartments, // 部門
                selectedLine: DEFAULT_STATE.selectedLine, // ライン名
                selectedClass: DEFAULT_STATE.selectedClass, // クラス名
                selectedSubclass: DEFAULT_STATE.selectedSubclass, // サブクラス名

                selectedItemCategory: DEFAULT_STATE.selectedItemCategory, // 商品区分
                selectedStopPurchaseFlag: DEFAULT_STATE.selectedStopPurchaseFlag, // 仕入れ止め
            }),
        }));
    };

    const handlePageClick = (event) => {
        const pageNumber = event.selected + 1;
        handleSubmitForm(pageNumber);
    };

    const handleSelectRow = (index, record) => {
        const responseData = apiResponse?.data;

        let targetRow = responseData.find((row) => row.jan === record.jan);

        if (!targetRow) return;
        let existingIndex = selectedRows.findIndex((row) => row.jan === record.jan);

        if (selectedRows.findIndex((row) => row.jan === record.jan) !== -1) {
            selectedRows.splice(existingIndex, 1);
        } else if (isSelectExcel || checkEnableSelect(isCompetitor, targetRow, selectedRows, isSelectExcel)) {
            selectedRows.push(targetRow);
        } else {
            selectedRows.length = 0;
            selectedRows.push(targetRow);
        }

        const isAllUnitSelected = isAllUnit(selectedRows);

        if (selectedRows.length === 0) {
            setState((prevState) => ({
                ...prevState,
                selectedRows: [],
                isAllUnitSelected: false,
                isChange: new Date(),
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                selectedRows,
                isAllUnitSelected: isAllUnitSelected,
                isChange: new Date(),
            }));
            // フォームの初期値を設定
            {
                !isSelectExcel &&
                    setFormData((formData) => ({
                        ...formData,
                        packingCategory: selectedRows[0].packingCategory,
                        salesStartDate: formattedDate(new Date()),
                    }));
            }
        }
    };

    const handleChangeState = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    // 「検索」ボタンをクリックした
    const handleSubmitForm = async (pageNumber) => {
        const searchFormData = {
            itemName,
            jan,
            selectedLine,
        };

        // 入力値チェック
        dispatch(clearErrors());
        if (validateSearchInput(dispatch, searchFormData, t)) return;

        dispatch(setLoader(true));
        dispatch(clearErrors());
        handleChangeState('page', pageNumber);

        let selectedDivision;
        let divisions;
        if (selectedLine) {
            selectedDivision = {
                departmentCode: selectedLine.departmentCode,
                lineCode: selectedLine.value,
                classCode: selectedClass?.value ?? 0,
                subclassCode: selectedSubclass?.value ?? 0,
            };
            divisions = [selectedDivision];
        } else {
            divisions = selectedDepartments.map((department) => {
                return {
                    departmentCode: department.value,
                    lineCode: 0,
                    classCode: 0,
                    subclassCode: 0,
                };
            });
        }

        // バリデーション許可更新
        ChangeRequestControllerService.getIsAllowChangeRequestWithoutValidation().then((response) => {
            dispatch(setIsAllowValidate(response));
        });

        const request = {
            divisions: divisions,
            itemName: itemName || null,
            searchMethod: searchMethod,
            jans: jan !== '' ? jan?.split(/[\s\u3000]+/) : null,
            itemCategory: selectedItemCategory ? selectedItemCategory : null,
            stopPurchaseFlag: selectedStopPurchaseFlag ? parseInt(selectedStopPurchaseFlag) : null,
            changeRequestType: changeRequestType,
            page: pageNumber,
            limit: limit,
            sortField: table.heads.find((head) => head.field === sort.sortField)?.field,
            sortType: sort.sortType,
        };

        const searchCountLimit = await PriceSearchControllerService.searchCount(request);

        if (!searchCountLimit) {
            PriceSearchControllerService.search(request)
                .then((response) => {
                    setState((prevState) => ({
                        ...prevState,
                        apiResponse: response,
                        isShowTableMaster: true,
                        isChange: new Date(),
                    }));
                })
                .catch((error) => {
                    apiChangeRequestErrorHandler(dispatch, error, '検索が失敗しました。再度検索をお願いします。');
                })
                .finally(() => {
                    dispatch(setLoader(false));
                });
        } else {
            dispatch(setLoader(false));
            handleChangeState('showSearchLimitCountModal', true);
        }
    };

    // 「クリア」ボタンをクリックした
    const handleClearForm = () => {
        setState({
            ...DEFAULT_STATE,
            selectedCompetitorStoreCode,
            requesterName,
            selectedSource,
            selectedRegistrationMethod,
            lines,
            apiResponse,
            isShowTableMaster,
            selectedRows,
        });
    };

    // 「選択クリア」ボタンをクリックした
    const handleClearSelect = () => {
        setState((prevState) => ({
            ...prevState,
            selectedRows: [],
        }));
    };

    const handleComplete = () => {
        history('/change-request/requesting');
    };

    // 「ダウンロード」ボタンをクリックした
    const handleExportFile = async () => {
        // TODO: limitテスト
        // if (selectedRows.length > 300) {
        //     dispatch(clearErrors());
        //     dispatch(setToastsError('ダウンロード上限数を越えています。\n300件以下でダウンロードしてください。'));
        //     return;
        // }

        const registerFormData = {
            competitorStoreCode: selectedCompetitorStoreCode,
            requesterName: requesterName,
            source: selectedSource,
            registrationMethod: selectedRegistrationMethod,
        };

        // 入力値チェック
        dispatch(clearErrors());
        if (validateRegisterInput(dispatch, registerFormData, isHead, isCompetitor)) return;

        // バックエンドからダウンロードするため、formを作成してリクエスト
        const form = document.createElement('form');
        form.action = `${env.BACKEND_BASE_URL}/api/export/excel`;
        form.method = 'POST';
        document.body.append(form);

        form.addEventListener('formdata', (e) => {
            const fd = e.formData;
            selectedRows.forEach((row, index) => {
                fd.set(`columns[${index}].jan`, row.jan);
                fd.set(`columns[${index}].itemName`, row.itemName);
                fd.set(`columns[${index}].capacityOfUnit`, row.capacityOfUnit);
                fd.set(`columns[${index}].lowestSellingPrice`, row.lowestSellingPrice);
                fd.set(`columns[${index}].edlpSellingPrice`, getLowerPrice(row.edlpSellingPrice, row.saratokuSellingPrice));
                fd.set(`columns[${index}].lowestPriceType`, row.lowestPriceType);
                fd.set(`columns[${index}].packingCategory`, row.packingCategory);

                fd.set(`columns[${index}].competitorStoreCode`, selectedCompetitorStoreCode);
                fd.set(`columns[${index}].requesterName`, requesterName);
                fd.set(`columns[${index}].source`, selectedSource);
            });
        });

        form.submit();
        form.remove();
    };

    // 登録フォームの「登録」ボタンをクリックした
    const handleRegistrationModalForm = async (step = 0) => {
        const mergedFormData = {
            ...formData,
            ...{
                competitorStoreCode: selectedCompetitorStoreCode,
                requesterName: requesterName,
                source: selectedSource,
                registrationMethod: selectedRegistrationMethod,
            },
        };

        // 入力値チェック
        dispatch(clearErrors());
        if (validateRegisterInput(dispatch, mergedFormData, isHead, isCompetitor)) return;
        if (validateFormInput(dispatch, mergedFormData, isFreshness, isInstruction)) return;

        dispatch(clearErrors());
        dispatch(setLoader(true));

        const discountedRequestSellingPrice = parseInt(mergedFormData.discountedRequestSellingPrice);

        const data = await Promise.all(
            selectedRows.map(async (row) => {
                return {
                    ...row,
                    ...mergedFormData,
                    discountedRequestSellingPrice,
                };
            }),
        );

        const sellingPriceData = await getSellingPrices(dispatch, data);

        const requestData = await Promise.all(
            sellingPriceData.map(async (row) => {
                const requestSellingPriceTax = getTaxIncludedPrice(row.requestSellingPrice, row.taxRate);
                const discountedRequestSellingPriceTax = getTaxIncludedPrice(row.discountedRequestSellingPrice, row.taxRate);
                return {
                    ...row,
                    requestSellingPriceTax,
                    discountedRequestSellingPriceTax,
                    taxIncludedType,
                };
            }),
        );
        if (!requestData) {
            dispatch(setLoader(false));
            return;
        }

        const validate = isCompetitor
            ? ChangeRequestControllerService.validateChangeRequestCompetitor(requestData)
            : isFreshness
              ? ChangeRequestControllerService.validateChangeRequestFreshness(requestData)
              : ChangeRequestControllerService.validateChangeRequestInstruction(requestData);

        try {
            await validate;
        } catch (error) {
            dispatch(setLoader(false));
            apiValidationErrorHandler(dispatch, error, requestData);
            return;
        }

        // 乖離を無視する場合があるため予めセットしておく
        setState((prevState) => ({
            ...prevState,
            requestData: requestData,
        }));

        // 乖離チェック
        if (await discountValidation(dispatch, requestData, isFreshness)) {
            dispatch(setLoader(false));
            return;
        }

        // 類似商品チェック
        if (await variantProdauctCheck(requestData)) {
            return;
        }

        // 重複チェック
        duplicateCheck(requestData);
    };

    useEffect(() => {
        if (isContinue) {
            // モーダル表示後に処理を続行する場合
            dispatch(setIsContinue(false));

            (async () => {
                // 類似商品チェック
                if (await variantProdauctCheck(requestData)) {
                    return;
                }

                // 重複チェック
                duplicateCheck(requestData);
            })();
        }
        if (isVariantProductsContinue) {
            // 類似商品があっても登録処理を続行
            dispatch(setIsVariantProductsContinue(false));

            // 重複チェック
            duplicateCheck(requestData);
        }
    }, [dispatch, isContinue, isVariantProductsContinue]);

    const variantProdauctCheck = async (requestData) => {
        dispatch(setLoader(true));
        if (isCompetitor) {
            const jans = requestData.map((data) => data.jan);
            const competitorChainCodes =
                competitorChains
                    ?.filter((item) => item.competitorChainCode === selectedCompetitorStoreCode.substring(0, 4))
                    .map((item) => item.competitorChainCode) ?? [];
            try {
                const variantProducts = await VariantProductControllerService.getVariantProducts({
                    jans: jans,
                    competitorChainCode: competitorChainCodes[0],
                });
                if (variantProducts.data.length > 0) {
                    dispatch(
                        setVariantProducts({
                            isShow: true,
                            items: variantProducts.data,
                        }),
                    );
                    dispatch(setLoader(false));
                    return true;
                }
            } catch (error) {
                dispatch(setLoader(false));
                apiErrorHandler(dispatch, error, t('message.error.registration'));
                return true;
            }
        }

        dispatch(setLoader(false));
        return false;
    };

    // 重複チェック
    const duplicateCheck = async (requestData) => {
        try {
            dispatch(setLoader(true));

            // 重複チェックAPIを呼ぶ
            const responseData = await ChangeRequestControllerService.checkDuplicateChangeRequest(
                changeRequestType,
                requestData.map((item) => ({
                    jan: item.jan,
                    competitorStoreCode: isCompetitor ? item.competitorStoreCode : null,
                    discountedRequestSellingPrice: item.discountedRequestSellingPrice,
                    salesStartDate: formData.salesStartDate,
                    salesEndDate: formData.salesEndDate,
                })),
            );

            dispatch(setLoader(false));

            // チェック結果を取得
            const duplicateItems = getErrorItems(responseData, requestData, ErrorMessage.errorType.DUPLICATE);

            // 重複が0件の場合
            if (!duplicateItems.length) {
                // 登録確認モーダルを開く
                handleChangeState('isShowModalRegister', true);
            }
            // 重複が1件以上の場合
            else {
                const close = () => {
                    setState((prevState) => ({
                        ...prevState,

                        duplicateModalIsShow: false,
                        duplicateModalProps: null,
                    }));
                };

                // 重複確認モーダルを開く
                setState((prevState) => ({
                    ...prevState,

                    duplicateModalIsShow: true,
                    duplicateModalProps: {
                        dataTable: duplicateItems,
                        isFreshness: isFreshness,
                        isContinuation: false,

                        // 「OK」ボタンが押された
                        onOk: () => {
                            // 重複確認モーダルを閉じる
                            close();

                            // 登録確認モーダルを開く
                            handleChangeState('isShowModalRegister', true);
                        },

                        // モーダルを閉じた or 「キャンセル」ボタンが押された
                        onClose: () => {
                            // 重複確認モーダルを閉じる
                            close();
                        },
                    },
                }));
            }
        } catch (error) {
            dispatch(setLoader(false));
            apiErrorHandler(dispatch, error);
        }
    };

    // 登録フォームの「キャンセル」ボタンをクリックした
    const handleCancelModalForm = () => {
        setFormData({
            ...DEFAULT_FORM_DATA,
        });
        setState((prevState) => ({
            ...prevState,
            selectedRows: [],
            isShowTableMaster: false,
        }));
    };

    const handleSubmitModalRegister = () => {
        handleChangeState('isShowModalRegister', false);
        dispatch(setLoader(true));
        dispatch(clearErrors());

        const request = isCompetitor
            ? ChangeRequestControllerService.createChangeRequestCompetitor('FORM', requestData)
            : isFreshness
              ? ChangeRequestControllerService.createChangeRequestFreshness('FORM', requestData)
              : ChangeRequestControllerService.createChangeRequestInstruction('FORM', requestData);

        request
            .then((response) => {
                // 連動商品が登録されていればモーダルを表示する
                if (!response) {
                    dispatch(setShowLinkedItem(true));
                }
                dispatch(setToastsSuccess('登録が完了しました。'));
                handleCancelModalForm();
            })
            .catch((error) => {
                apiValidationErrorHandler(dispatch, error, requestData, t('message.error.registration'));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

    const handleCloseModal = () => {
        handleChangeState('showLowerLimitModal', false);
        handleChangeState('showSearchLimitCountModal', false);
    };

    const lowerLimitTable = getLowerLimitTable(t);

    return (
        <>
            <div className="okc-inner">
                <Card
                    isCompletion={!isHiddenButtonCompletion}
                    handleSubmit={() => handleSubmitForm(1)}
                    handleClear={handleClearForm}
                    handleCompletion={!isHiddenButtonCompletion && handleComplete}
                >
                    {isHead ? (
                        // 競合チェーン選択&入力者名
                        <>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.competitive_chain.title')}
                                className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                                isRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <SelectSearch
                                    placeholder={t('price_registration.search_form.competitive_chain.placeholder')}
                                    onChange={(target) => {
                                        handleChangeState('selectedCompetitorStoreCode', target.value);
                                    }}
                                    options={createCompetitorStoreOptions()}
                                    value={selectedCompetitorStoreCode}
                                />
                            </div>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.requester_name.title')}
                                className="col-lg-2 pl-lg-3 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                                isRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    placeholder={t('price_registration.search_form.requester_name.placeholder')}
                                    type="text"
                                    maxLength="45"
                                    onChange={(value) => handleChangeState('requesterName', value)}
                                    value={requesterName}
                                />
                            </div>
                        </>
                    ) : isCompetitor ? (
                        // 競合店舗選択&入力者名
                        <>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.survey.title')}
                                className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                                isRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <SelectSearch
                                    placeholder={t('price_registration.search_form.survey.placeholder')}
                                    onChange={(target) => {
                                        handleChangeState('selectedCompetitorStoreCode', target.value);
                                    }}
                                    options={createCompetitorStoreOptions()}
                                    value={selectedCompetitorStoreCode}
                                />
                            </div>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.requester_name.title')}
                                className="col-lg-2 pl-lg-3 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                                isRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    placeholder={t('price_registration.search_form.requester_name.placeholder')}
                                    type="text"
                                    maxLength="45"
                                    onChange={(value) => handleChangeState('requesterName', value)}
                                    value={requesterName}
                                />
                            </div>
                        </>
                    ) : (
                        // 入力者名
                        <>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.requester_name.title')}
                                className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                                isRequired={true}
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <Input
                                    className="form-control form-control--input"
                                    placeholder={t('price_registration.search_form.requester_name.placeholder')}
                                    type="text"
                                    maxLength="45"
                                    onChange={(value) => handleChangeState('requesterName', value)}
                                    value={requesterName}
                                />
                            </div>
                            <div className="col-lg-6 pr-lg-3 mb-4"></div>
                        </>
                    )}
                    {!isHead && isCompetitor && (
                        // 情報取得元&登録方法
                        <>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.source.title')}
                                className="col-lg-2 mb-2 mb-lg-4 mt-lg-2 align-self-start"
                            />
                            <div className="col-lg-4 mb-4 competitive-store__radios">
                                <div className="row m-0 competitive-store__row">
                                    <Choice
                                        id="source"
                                        column="col-xl-3 col-lg-4 col-md-5"
                                        type="radio"
                                        data={sources}
                                        onChange={(value) => handleChangeState('selectedSource', value[0])}
                                        checked={[selectedSource]}
                                    />
                                </div>
                            </div>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.registration_method.title')}
                                className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                            />
                            <div className="col-lg-4 mb-4 competitive-store__radios">
                                <div className="row m-0 competitive-store__row">
                                    <Choice
                                        id="registrationMethod"
                                        column="col-xl-3 col-lg-4 col-md-5"
                                        type="radio"
                                        data={registrationMethods}
                                        onChange={(value) => {
                                            handleChangeState('selectedRegistrationMethod', value[0]);
                                            handleChangeState('selectedRows', []);
                                        }}
                                        checked={[selectedRegistrationMethod]}
                                        isHidden={isIOS()}
                                        hiddenValues={['EXCEL']}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <hr className="row okc-border" />

                    <div className="col-lg-12 mb-2 competitive-store__radios"></div>
                    <Label
                        type="column"
                        text={t('price_registration.search_form.product_name.title')}
                        className="col-lg-2 mb-2 mb-lg-4"
                        isEitherOneRequired={true}
                    />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <Input
                            className="form-control form-control--input"
                            type="text"
                            placeholder={t('price_registration.search_form.product_name.placeholder')}
                            autocomplete="off"
                            maxLength="60"
                            name="itemName"
                            onChange={(value) => handleChangeState('itemName', value)}
                            value={itemName}
                            disabled={jan !== ''}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('price_registration.search_form.department_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <MultiSelect
                            placeholder={t('price_registration.search_form.department_name.placeholder')}
                            options={departments}
                            value={selectedDepartments}
                            onChange={(value) => handleChangeState('selectedDepartments', value)}
                            disabled={jan !== ''}
                        />
                    </div>
                    <Label type="column" className="col-lg-2 mb-2 mb-lg-4" />
                    <div className="col-lg-4 pr-lg-3 mb-4">
                        <div className="row w-100 m-0">
                            <div className="col-12 mb-2 mb-lg-1">{t('price_registration.search_form.search_method.title')}</div>
                            <Choice
                                id="searchMethod"
                                column="col-lg-4"
                                type="radio"
                                data={SEARCH_METHOD}
                                onChange={(value) => handleChangeState('searchMethod', value[0])}
                                checked={[searchMethod]}
                                disabled={jan !== ''}
                            />
                        </div>
                    </div>
                    <Label
                        type="column"
                        text={t('price_registration.search_form.line_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                        isEitherOneRequired={true}
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={lines}
                            placeholder={t('price_registration.search_form.line_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedLine', value)}
                            value={selectedLine?.value}
                            disabled={jan !== ''}
                        />
                    </div>
                    <Label
                        type="column"
                        text={t('price_registration.search_form.jan.title')}
                        className="col-lg-2 mb-2 mb-lg-4"
                        isEitherOneRequired={true}
                    />
                    <InputJan
                        divClass="col-lg-4 pr-lg-3 mb-4"
                        inputClass="form-control form-control--input"
                        jan={jan}
                        placeholder={t('price_registration.search_form.jan.placeholder')}
                        onChange={handleJanChange}
                        name="jan"
                        isCameraOpen={isCameraOpen}
                        onOpen={() => handleChangeState('isCameraOpen', true)}
                        onClose={() => handleChangeState('isCameraOpen', false)}
                    />
                    <Label
                        type="column"
                        text={t('price_registration.search_form.class_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={classes}
                            placeholder={t('price_registration.search_form.class_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedClass', value)}
                            value={selectedClass?.value}
                            disabled={!selectedLine || !classes.length}
                        />
                    </div>
                    <Label type="column" className="col-lg-2 mb-2 mb-lg-4" />
                    <div className="col-lg-4 pr-lg-3 mb-4"></div>
                    <Label
                        type="column"
                        text={t('price_registration.search_form.subclass_name.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4"
                    />
                    <div className="col-lg-4 mb-4">
                        <SelectSearch
                            isClearable={true}
                            options={subclasses}
                            placeholder={t('price_registration.search_form.subclass_name.placeholder')}
                            onChange={(value) => handleChangeState('selectedSubclass', value)}
                            value={selectedSubclass?.value}
                            disabled={!selectedClass || !subclasses.length}
                        />
                    </div>
                    {!isFreshness && (
                        <>
                            <Label
                                type="column"
                                text={t('price_registration.search_form.product_category.title')}
                                className="col-lg-2 mb-2 mb-lg-4 form-check-label"
                            />
                            <div className="col-lg-4 pr-lg-3 mb-4">
                                <div className="row no-gutters w-100 product-category">
                                    <Choice
                                        id="categories"
                                        column="col-lg-4"
                                        type="radio"
                                        data={itemCategories}
                                        onChange={(target) => handleChangeState('selectedItemCategory', target[0])}
                                        checked={[selectedItemCategory]}
                                        disabled={jan !== ''}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <Label
                        type="column"
                        text={t('price_registration.search_form.stop_purchase.title')}
                        className="col-lg-2 pl-lg-3 mb-2 mb-lg-4 form-check-label stop-purchase"
                    />
                    <div className="col-lg-4 mb-4">
                        <div className="row no-gutters w-100 stop-purchase">
                            <Choice
                                id="stockStopped"
                                column="col-lg-4"
                                type="radio"
                                data={STOP_PURCHASE_FLAG}
                                onChange={(target) => handleChangeState('selectedStopPurchaseFlag', target[0])}
                                checked={[selectedStopPurchaseFlag]}
                                disabled={jan !== ''}
                            />
                        </div>
                    </div>
                    <EitherOneRequiredText />
                </Card>
                {isShowTableMaster && (
                    <>
                        <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                        <div className="okc-table okc-table__parent c-slide-top okc-table--margin-bottom20">
                            <SelectTable
                                heads={table.heads}
                                body={table.body}
                                dataTable={apiResponse?.data}
                                isSelectRow={true}
                                isMultiSelectRow={isSelectExcel}
                                onSelectRow={handleSelectRow}
                                selectedRows={selectedRows}
                                isAllowValidate={isAllowValidate}
                                isSelectExcel={isSelectExcel}
                                isChange={isChange}
                                page={page}
                            />
                        </div>
                        <div className="d-flex okc-pagination-bottom justify-content-between">
                            <div>
                                <Button className="btn btn--secondary" onClick={handleClearSelect}>
                                    <span>{t('button.clear_select')}</span>
                                </Button>
                            </div>
                            <Pagination pageCount={apiResponse?.totalPage} onPageChange={handlePageClick} page={page} />
                        </div>
                    </>
                )}
                {isShowTableMaster && selectedRows.length > 0 && (
                    <>
                        {isSelectExcel ? (
                            // Excel
                            <>
                                <div className="okc-table okc-table__child okc-table--margin-bottom18">
                                    <div className="text-center okc-table-title">
                                        <span>売価登録一覧</span>
                                    </div>
                                    <EditTable heads={tableSelect.heads} body={tableSelect.body} dataTable={selectedRows} />
                                </div>
                                <div className="d-flex justify-content-end c-slide-top mb-5">
                                    <Button
                                        className="btn btn--primary btn-block"
                                        id="buttonExport"
                                        onClick={handleExportFile}
                                        children={<span className="btn-text">{t('button.download')}</span>}
                                    />
                                </div>
                            </>
                        ) : (
                            // フォーム
                            <>
                                <div className="okc-table okc-table__child okc-table--margin-bottom">
                                    <div className="text-center okc-table-title">
                                        <span>売価登録一覧</span>
                                    </div>
                                    <ViewTable heads={tableSelect.heads} body={tableSelect.body} dataTable={selectedRows} />
                                </div>
                                <div id="result-form-wrapper">
                                    <CardPriceSearch
                                        formData={formData}
                                        setFormData={setFormData}
                                        taxRate={selectedRows[0]?.taxRate}
                                        capacityOfUnit={selectedRows[0]?.capacityOfUnit}
                                        quantityOfUnit={selectedRows[0]?.quantityOfUnit}
                                        unit={selectedRows[0]?.unit}
                                        discountedLowestSellingPrice={selectedRows[0]?.discountedLowestSellingPrice}
                                        isRegistration={true}
                                        taxIncludedType={taxIncludedType}
                                        setTaxIncludedType={setTaxIncludedType}
                                        isAllUnitSelected={isAllUnitSelected}
                                    />
                                    <div className="d-flex justify-content-end c-slide-top mb-5 submit-btn">
                                        <Button className="btn btn--primary" onClick={handleRegistrationModalForm}>
                                            <span className="btn-text">{t('button.registration')}</span>
                                        </Button>
                                        <Button className="btn btn--secondary ml-2" onClick={handleCancelModalForm}>
                                            <span className="btn-text">{t('button.cancel')}</span>
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
                <Modal
                    size="xll"
                    isShow={isShowModalRegister}
                    onClose={() => handleChangeState('isShowModalRegister', false)}
                    isShowIconClose="true"
                    title={t('price_registration.registration_list_modal.title')}
                    btnList={[
                        {
                            name: t('price_registration.registration_list_modal.ok_button'),
                            className: 'btn--primary',
                            onClick: () => handleSubmitModalRegister(),
                            disabled: false,
                        },
                        {
                            name: t('price_registration.registration_list_modal.cancel_button'),
                            className: 'btn--secondary master-edit-modal__submit',
                            onClick: () => handleChangeState('isShowModalRegister', false),
                            disabled: false,
                        },
                    ]}
                    children={
                        <>
                            {isCompetitor && (
                                <p className="font-weight-bold">
                                    {
                                        competitorStores?.find((item) => item.competitorStoreCode === selectedCompetitorStoreCode)
                                            ?.competitorStoreName
                                    }
                                </p>
                            )}

                            <ViewTable heads={tableRequest.heads} body={tableRequest.body} dataTable={requestData} />
                        </>
                    }
                />
                <Modal
                    isShow={showLowerLimitModal}
                    onClose={handleCloseModal}
                    size="xl"
                    title={t('modal.common_modal.title')}
                    isShowIconClose="true"
                    btnList={[
                        {
                            name: t('price_registration.competitor_prohibited_items_modal.body.button'),
                            className: 'btn--primary',
                            onClick: () => handleCloseModal(),
                        },
                    ]}
                    children={
                        <>
                            <p className="text-center">{t('price_registration.competitor_prohibited_items_modal.body.text01')}</p>
                            <ViewTable heads={lowerLimitTable.heads} body={lowerLimitTable.body} dataTable={lowerLimitData} />
                        </>
                    }
                />
                <Modal
                    isShow={showSearchLimitCountModal}
                    onClose={handleCloseModal}
                    size="lg"
                    title={t('modal.common_modal.title')}
                    isShowIconClose="true"
                    btnList={[
                        {
                            name: t('price_registration.competitor_prohibited_items_modal.body.button'),
                            className: 'btn--primary',
                            onClick: () => handleCloseModal(),
                        },
                    ]}
                    children={
                        <>
                            <p className="text-center">{t('price_registration.search_count_limit_modal.body.text01')}</p>
                            <p className="text-center">{t('price_registration.search_count_limit_modal.body.text02')}</p>
                        </>
                    }
                />

                {/* 重複確認モーダル */}
                {duplicateModalIsShow && <DuplicateModal {...duplicateModalProps} />}
            </div>
        </>
    );
};

export default PriceSearch;
